import { useState, useEffect } from "react"
import loyaltyCommissionService from "../services/LoyaltyCommissionService"

export const useUserLoyaltyCommission = (userId: number) => {
  const [commission, setCommission] = useState<any>(null)
  const [loading, setLoading] = useState(true) // Commence par true
  const [error, setError] = useState<string | null>(null)

  const fetchCommission = async () => {
    // Ne pas charger si userId n'est pas valide
    if (!userId || userId === 0) {
      setCommission(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await loyaltyCommissionService.getUserActiveCommission(userId)
      console.log( 'response', response )
      setCommission(response.success ? response.commission : null)
    } catch (err: any) {
      setError(err.message || "Erreur lors de la récupération de la commission")
      setCommission(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCommission()
  }, [userId])

  // Calcul de la commission
  const applyCommission = (basePrice: number) => {
    if (!commission || !commission.isActive || commission.commissionPercentage <= 0) return basePrice
    return Math.max(0, basePrice - (basePrice * commission.commissionPercentage) / 100)
  }

  return { commission, loading, error, applyCommission, refetch: fetchCommission }
}

export default useUserLoyaltyCommission
